export default "__VITE_ASSET__DOL5qK$W__"